import React, { Component } from "react";


class EducationRight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      skill: [
        {
          id: 1,
          timeline: "timeline-inverted color1",
          info: "Just IT",
          title: "Software and Web development level 3 Certificate",
          text: "Gained foundational skills in front-end and scripting languages including HTML, CSS, JavaScript, and Python."
        },
        
        {
          id: 2,
          timeline: "timeline-inverted color1",
          info: "Avanade Academy",
          title: "Software and Web Development Certificate",
          text: "Focused on back-end development fundamentals using C# and SQL, with practical exposure to enterprise-grade coding standards."
        },

        {
          id: 3,
          timeline: "timeline-inverted color1", 
          info: "Higher Degree",
          title: "Level 4 Software Developer Degree",
          text: "Comprehensive training in full-stack development, covering C#, SQL, JavaScript, HTML, CSS, and modern web engineering practices. Emphasis on scalable architecture and secure coding.",
        },
      ],
    };
  }
  render() {
    return (
      <div className="col-right">
        <div
          className="flat-spacer"
          data-desktop={0}
          data-mobile={70}
          data-smobile={70}
        />
        <div className="flat-title t1 animate-element wow delay5 fadeInDown">
          <h4 className="sub-title mg-b13">Educational qualification</h4>
          <h2 className="title-section color-d12">My Education</h2>
        </div>
        <div
          className="timelines position-relative animate-element wow delay5 fadeInUp"
          data-wow-delay="0.5s"
        >
          <ul className="timeline">
            {this.state.skill.map((data) => (
              <li className={data.timeline} key={data.id}>
                <div className="timeline-badge" />
                <div className="timeline-panel">
                  <h3 className="f-info">{data.info}</h3>
                  <div className="s-info">{data.title}</div>
                  <p>{data.text}</p>
                </div>
              </li>
            ))}
          </ul>
        
        </div>
      </div>
    );
  }
}

export default EducationRight;
